import React from 'react'
import { Content } from 'components/SwitchAndGauge/DashDrawer/Sections'
import { Header, Paragraph } from 'components/patterns'
import strings from 'utils/strings'
import styled from '@emotion/styled'
import { makeComponentMetaSelector } from 'selectors/navigator'
import { useMakeSelector } from 'hooks/redux'
import { DASH_VIEW } from 'utils/constants'
import { StyledViewWrap } from './style'

const ErrorView = () => {
  const { id: searchTerm } = useMakeSelector(makeComponentMetaSelector, {
    id: DASH_VIEW,
  })

  return (
    <StyledViewWrap>
      <Content>
        <StyledHeader type="h3">
          {`${strings.search_for_result}:`}
          <span style={{ fontWeight: 'bold' }}>{` "${searchTerm}"`}</span>
        </StyledHeader>
        <NotFoundMessage>
          <StyledIcon />
          <Paragraph>{strings.not_found_qr}</Paragraph>
        </NotFoundMessage>
      </Content>
    </StyledViewWrap>
  )
}

export default ErrorView

const StyledHeader = styled(Header)`
  font-weight: normal;
`

const NotFoundMessage = styled.div`
  display: flex;
  margin-top: 8px;
  flex-direction: row;

  ${Paragraph} {
    flex: 83%;
  }
`

const SvgComponent = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.122 7.88 12.121.877a3.001 3.001 0 0 0-4.242 0L.878 7.879a3 3 0 0 0 0 4.242l7.001 7.001a3 3 0 0 0 4.242 0l7.001-7.001a3.001 3.001 0 0 0 0-4.242zm-5.166 5.148a.975.975 0 0 0-.287-.69l-2.281-2.345 2.33-2.324a.975.975 0 0 0-.692-1.667.98.98 0 0 0-.692.286l-2.32 2.324-2.33-2.324a.99.99 0 0 0-1.682.715c.003.262.11.512.297.695l2.33 2.325-2.33 2.314a.975.975 0 0 0 .693 1.667.98.98 0 0 0 .692-.286l2.28-2.324 2.32 2.324a.98.98 0 0 0 1.672-.69z"
      fill="#B4040C"
    />
  </svg>
)

const StyledIcon = styled(SvgComponent)`
  flex: 1;
`
